import { useI18n } from "../context/I18nContext";
import { Overline, Reveal } from "./Reveal";

export default function GranadaSection() {
  const { t } = useI18n();

  return (
    <section id="granada" data-testid="granada-section" className="bg-bone py-24 text-charcoal md:py-32">
      <div className="mx-auto max-w-4xl px-5 text-center md:px-10">
        <Reveal>
          <Overline className="justify-center">{t.granada.overline}</Overline>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="mt-6 font-serif text-3xl leading-tight sm:text-4xl lg:text-5xl">
            {t.granada.title}
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="mx-auto mt-7 max-w-2xl text-lg leading-relaxed text-charcoal/70">
            {t.granada.text}
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <p className="mt-9 text-[11px] uppercase tracking-[0.3em] text-stonekw">{t.granada.meta}</p>
        </Reveal>
      </div>
    </section>
  );
}
